import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { listWarehouseApi } from "../../auth/authService";

export const fetchMasterWarehouses = createAsyncThunk(
    "masterWarehouses/fetchMasterWarehouses",
    async (params = {}, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.token;

            const {
                page = 1,
                per_page = 10,
                search = ""
            } = params;

            const res = await listWarehouseApi(token, {
                page,
                per_page,
                search
            });

            return res;
        } catch (err) {
            console.log("ERROR:", err);
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil data"
            );
        }
    }
);


const masterWarehousesSlice = createSlice({
    name: "masterWarehouses",
    initialState: {
        data: [],
        pagination: {},
        loading: false,
        error: null,
    },
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchMasterWarehouses.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMasterWarehouses.fulfilled, (state, action) => {
                //console.log("FULLFILLED PAYLOAD:", action.payload);
                state.loading = false;
                state.data = action.payload.data;
                //console.log("PAYLOAD:", action.payload);
            })
            .addCase(fetchMasterWarehouses.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                //console.log("REJECTED:", action.payload);
            });
    },
});

export default masterWarehousesSlice.reducer;